import { obtenerMensajeError } from "utils/apiErrors";
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Alert,
  Dialog,
  DialogTitle,
  Select,
  MenuItem,
  DialogContent,
  DialogActions,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import Grid from "@mui/material/Grid2";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";

import PDFApi from "api/pdfApi";
import BucketApi from "api/bucketApi";
import ProcesosApi from "api/procesosApi";

const TerminarProceso = ({ open, onClose, audienciaId, audiencia: audienciaProp, onSuccess }) => {
  const [error, setError] = useState(undefined);
  const [audiencia, setAudiencia] = useState(null);
  const [newTerminacion, setNewTerminacion] = useState({
    tipo_terminacion: null,
    fecha_desistimiento: "",
    manifestaciones_reforma: "",
  });
  const [saving, setSaving] = useState(false);

  const fetchInitialData = async () => {
    try {
      // Si se pasa la audiencia como prop, usarla directamente
      if (audienciaProp) {
        setAudiencia(audienciaProp);
        return;
      }
      // Solo hacer fetch si no se pasa la audiencia como prop
      const audienciaResp = await ProcesosApi.fetchAudienciaById(audienciaId);
      setAudiencia(audienciaResp.data);
    } catch (error) {
      console.error("Error al obtener los datos iniciales:", error);
      setError(obtenerMensajeError(error, "Error al cargar los datos iniciales."));
    }
  };

  useEffect(() => {
    if (open && (audienciaId || audienciaProp)) {
      fetchInitialData();
    }
  }, [audienciaId, audienciaProp, open]);

  // Actualizar audiencia local cuando cambie la prop
  useEffect(() => {
    if (audienciaProp) {
      setAudiencia(audienciaProp);
    }
  }, [audienciaProp]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    //alert("newTerminacion: " + JSON.stringify(newTerminacion));
    if (!newTerminacion.tipo_terminacion) {
      alert("Debe seleccionar un Tipo de Terminación.");
      return;
    }
    if (
      newTerminacion.tipo_terminacion == "Desistimiento" &&
      newTerminacion.fecha_desistimiento == ""
    ) {
      setError("Debes registrar la Fecha de Desistimiento.");
      return;
    }
    if (
      newTerminacion.tipo_terminacion == "Reforma de Acuerdo" &&
      newTerminacion.manifestaciones_reforma == ""
    ) {
      setError("Debes registrar las Manifestaciones de las Partes.");
      return;
    }
    const confirmacion = window.confirm(`¿Está seguro(a) de que desea terminar el Proceso?`);
    if (!confirmacion) return;
    try {
      setSaving(true);
      let OPERACION = "";
      let RESULTADO = "";
      let FILE_NAME = "";
      let ANEXO_TYPE = "";
      let ANEXO_NOMBRE = "";
      let FORMATO = "";
      if (newTerminacion.tipo_terminacion == "Desistimiento") {
        OPERACION = "TERMINAR_PROCESO";
        RESULTADO = "proceso_terminado";
        FILE_NAME = "pdf_terminacion.pdf";
        ANEXO_TYPE = "PDF_TERMINACION";
        ANEXO_NOMBRE = "Acta Terminación";
        FORMATO = "actaTerminacionProceso";
      }
      if (newTerminacion.tipo_terminacion == "Reforma de Acuerdo") {
        OPERACION = "REFORMAR_ACUERDO_PROCESO";
        RESULTADO = "proceso_en_acuerdo";
        FILE_NAME = "pdf_reforma_acuerdo.pdf";
        ANEXO_TYPE = "PDF_REFORMA_ACUERDO";
        ANEXO_NOMBRE = "Acta Reforma Acuerdo";
        FORMATO = "actaReformaAcuerdo";
      }
      if (newTerminacion.tipo_terminacion == "Incumplimiento") {
        OPERACION = "INCUMPLIR_PROCESO";
        RESULTADO = "proceso_incumplido";
        FILE_NAME = "pdf_incumplimiento.pdf";
        ANEXO_TYPE = "PDF_INCUMPLIMIENTO";
        ANEXO_NOMBRE = "Fracaso Incumplimiento";
        FORMATO = "actaFracasoIncumplimiento";
      }
      const updatedAudiencia = {
        ...audiencia,
        estado: "CERRADA",
        resultado: RESULTADO,
        etapas: audiencia.etapas.map((etapa) =>
          etapa.orden === 6 // RESULTADO
            ? {
                ...etapa,
                resultado: {
                  ...etapa.resultado,
                  tipo_terminacion: newTerminacion.tipo_terminacion,
                  manifestaciones_reforma: newTerminacion.manifestaciones_reforma,
                  fecha_desistimiento: newTerminacion.fecha_desistimiento,
                },
              }
            : etapa
        ),
      };
      await ProcesosApi.actualizarAudiencia(audiencia.id, updatedAudiencia);
      const datosTerminarProceso = {
        operacion: OPERACION,
        tipo_terminacion: newTerminacion.tipo_terminacion,
        id_audiencia: audiencia.id,
        fecha_desistimiento: newTerminacion.fecha_desistimiento,
      };
      const response = await ProcesosApi.operarAudiencia(datosTerminarProceso);
      if (response.status === 201 && response.data) {
        const anexoResponse = await ProcesosApi.obtenerAnexoProcesoByTipo(audiencia.proceso, {
          tipo_anexo: ANEXO_TYPE,
        });
        const anexo = anexoResponse.data;
        if (anexo != undefined && !anexoResponse.data.error) {
          await ProcesosApi.eliminarAnexoProceso(audiencia.proceso, anexo.id);
        }
        // Generar PDF ACTUALIZACION ACREECNCIAS
        const pdfResponse = await PDFApi.generateDocument(FORMATO, audiencia.id);
        const pdfBlob = new Blob([pdfResponse.data], { type: "application/pdf" });
        const formData = new FormData();
        formData.append("file", pdfBlob, FILE_NAME);
        formData.append("file_type", "proceso");
        formData.append("proceso_id", audiencia.proceso_identificador);
        formData.append("registrar_anexo", "true");
        formData.append("tipo_anexo", ANEXO_TYPE);
        formData.append("nombre_anexo", ANEXO_NOMBRE);
        await BucketApi.uploadFile(formData);
        resetState();
        alert("El Proceso ha sido terminado correctamente.");
        onSuccess();
      }
    } catch (error) {
      console.error("Error en al Terminar el Proceso:", error);
      alert(obtenerMensajeError(error, "Ocurrió un error al Terminar el Proceso."));
    } finally {
      setSaving(false);
    }
  };

  const resetState = () => {
    setError(undefined);
    setNewTerminacion({
      tipo_terminacion: null,
      fecha_desistimiento: "",
      manifestaciones_reforma: "",
    });
  };

  const hCClose = () => {
    resetState();
    onClose();
  };

  return (
    <>
      {saving && (
        <Backdrop open={true} style={{ zIndex: 9999, color: "#fff" }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
      <Dialog open={open} onClose={hCClose} maxWidth="md" fullWidth>
        <DialogTitle>
          <SuiBox mt={1}>
            <strong>
              Terminar el Proceso: {audiencia?.proceso_identificador || "No tiene Proceso"}
            </strong>
          </SuiBox>
        </DialogTitle>
        <DialogContent>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={12}>
              {error && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {error}
                </Alert>
              )}
            </Grid>
          </Grid>
          <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
            <Grid size={6}>
              <SuiTypography variant="h6" fontWeight="light">
                Tipo Terminación
              </SuiTypography>
              <Select
                value={newTerminacion.tipo_terminacion}
                onChange={(e) =>
                  setNewTerminacion({ ...newTerminacion, tipo_terminacion: e.target.value })
                }
                displayEmpty
                fullWidth
              >
                <MenuItem value="Desistimiento">Desistimiento</MenuItem>
                <MenuItem value="Reforma de Acuerdo">Reforma de Acuerdo</MenuItem>
                <MenuItem value="Incumplimiento">Incumplimiento</MenuItem>
              </Select>
            </Grid>
          </Grid>
          {newTerminacion.tipo_terminacion === "Desistimiento" && (
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={12}>
                <SuiTypography variant="h6" fontWeight="light">
                  Fecha Desistimiento
                </SuiTypography>
                <SuiInput
                  fullWidth
                  type="date"
                  name="fecha_desistimiento"
                  value={newTerminacion.fecha_desistimiento}
                  onChange={(e) =>
                    setNewTerminacion({ ...newTerminacion, fecha_desistimiento: e.target.value })
                  }
                  InputLabelProps={{ shrink: true }}
                  required
                />
              </Grid>
            </Grid>
          )}
          {newTerminacion.tipo_terminacion === "Reforma de Acuerdo" && (
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 1, md: 1 }}>
              <Grid size={12}>
                <SuiTypography variant="h6" fontWeight="light">
                  Manifestación de las Partes
                </SuiTypography>
                <SuiInput
                  name="manifestaciones"
                  multiline
                  rows={4}
                  value={newTerminacion.manifestaciones_reforma}
                  onChange={(e) =>
                    setNewTerminacion({
                      ...newTerminacion,
                      manifestaciones_reforma: e.target.value,
                    })
                  }
                  fullWidth
                />
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <SuiButton onClick={hCClose} color="secondary">
            Cancelar
          </SuiButton>
          <SuiButton variant="gradient" buttonColor="error" onClick={handleSubmit}>
            Terminar
          </SuiButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

TerminarProceso.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  audienciaId: PropTypes.int,
  audiencia: PropTypes.object,
  onSuccess: PropTypes.func.isRequired,
};

export default TerminarProceso;
